module.exports = __webpack_public_path__ + "static/media/Leash_Geometric_01.9a39988a.png";